/*
 * Aro Config
 */
const DEFAULT_ARO_CONFIG = {
  //Aro BasePath
  aroBaseUrl : "/app/ro/aroShop",
  //Aro Api BasePath
  aroApiBaseUrl : "http://localhost:3000/api",
  //Aro Zip BasePath
  zipApiBaseUrl : "http://localhost:3000/zipApi/zipcode/v1.0",
  //Shop Basket Page Path
  shopBasketPageUrl : "/app/sp/Cart",
  //Shop Gift Basket Page Path
  shopGiftBasketPageUrl : "/app/sp/CartGift",
  //Aro Channel
  channel : "1", //WEB(Nuskin):1, MOBILE(Nuskin):1, ME_COMMERCE:7
  //Open Modal body className
  openModalBodyClassName : "openLayerPopup", //Nuksin:openLayerPopup , ME_COMMERCE:modal-open

  loginInfo : {
    memberId:'KR0000001',
    //memberId:null,
    nm_kr:'관리자',
    memberType:'DIST',
    authKey : 'c4c1d7143d394e3693021449a1057d9c'
  },
  mode:0, //0:normal mode , 1: hidden integration
  integrationMode : 0, //0:None 1: Add cart integration

  usingGraceFunction : false,

  //Integration Functions
  fn_showLoading : function(callback) {
	  $("#loadingBox").css({width: $(document).width(), height: $(document).height()}).show(typeof callback === "function" ? callback : null);
  },
  fn_hideLoading : function() {
	  $("#loadingBox").hide();
  },
  fn_openLoginConfirm : function(){
    //alert("배너 표시");
    console.debug("Nuskin 배너 표시");
  },
  fn_showProductBanner : function(){
    console.debug("Nuskin Login Confirm 표시");
    //openUrlLayer("안내", "로그인이 필요합니다. 로그인 하시겠습니까?", '/app/mo/Login');
  },
  fn_uiInitialize : function(){
    if(typeof aroUiInitializeForVuejs === "function"){
      aroUiInitializeForVuejs.call();
    }
  },
  fn_aroSnsInit : function(){
    console.debug("[raw] ARO SNS 초기화");
  },
  fn_aroSnsShareAction : function(snsTitle, shareLinkUrl, shareImgUrl, snsType){
    console.debug("[raw]ARO SNS 공유");
  },
  fn_aroUrlShareAction : function(shareLinkUrl){
    console.debug("[raw]ARO URL 공유");
  },
  fn_changeBasketCount : function(){
    console.debug("[raw] 장바구니 변경");
  },
  fn_sendAroGA : function(dataObj, callback){
    console.debug("[raw] GA 전송");
    console.debug(`dataObj:${JSON.stringify(dataObj, null, 4)}`);

    if(typeof callback === "function"){
      callback.call();
    }
  },
  fn_imageError : function(img){
    console.debug("[raw]ARO 이미지 에러");
  },
};
export function getGlobalAroConfig () {
  let val = null;
  try{
    val = {
      ...DEFAULT_ARO_CONFIG,
      ...gVueAroConfig
    };
  }catch(e){
    val = DEFAULT_ARO_CONFIG;
  }

  return val;
}

/**
 * 카드번호 분할
 * @param {String}} number
 */
export function getArrayForCardNumber(number) {
  var values = [];
  if (undefined != number) {
      var numberVal = number;
      if (-1 < number.indexOf('-')) { //2015.01.01 경우 =>  2015/01/01 변경
          numberVal = number.replace(/[-]/g, "");
      }

      var size = numberVal.length;
      if (12 <= size) {
          values[0] = numberVal.substring(0, 4);
          values[1] = numberVal.substring(4, 8);
          values[2] = numberVal.substring(8, 12);
          var lastPos = size;
          if (size > 16) {
              lastPos = 16;
          }

          values[3] = numberVal.substring(12, lastPos);

      } else {
          values[0] = numberVal;
      }
  }

  return values;
};



// WEBPACK FOOTER //
// ./src/utils/common.js